import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/industries/agritech/original-page.tsx");
